<script>
  export let logoSrc = "/images/flecha_punteada.svg";
  export let iconLightBulb = "/icons/light_bulb.svg";
  // import { onMount } from "svelte";
  import { setupI18n, changeLocale, _ } from "../../../../helpers/i18n.js";
  import { globalStore } from "../store/globalStore";
  import { setupPageTracking } from '../../helpers/analytics.js';
  import { ButtonV2 } from "$lib";
  import { navbarOptions } from "$constants/navbarOptions.js";
  // import TourGuide from "../../lib/tour-guide/TourGuide.svelte";

  // const TOUR_STORAGE_KEY = "menu_tour_shown";

  let windowWidth = window.innerWidth;
  // let startTour = false;
  // let tourInProgress = false;

  const urlParams = new URLSearchParams(window.location.search);
  const paramCountry = urlParams.get('country') ?? 'cl';

  setupPageTracking('home');

  const i18nSetup = setupI18n(paramCountry);

  const { country } = globalStore;

  // Reaccionar a cambios en el país del globalStore
  $: if ($country) {
    changeLocale($country);
  }

  // $: if ($globalStore.isMenuMobileOpen && tourInProgress) {
  //   handleTourEnd();
  // }

  // $: tourSteps = [
  //   {
  //     element: "#menu-toggle-btn",
  //     popover: {
  //       title: $_("tour_guide.title"),
  //       description: $_("tour_guide.description"),
  //       side: "bottom",
  //     }
  //   }
  // ];

  // onMount(() => {
  //   if (windowWidth < 768 && !localStorage.getItem(TOUR_STORAGE_KEY)) {
  //     const startTourDelayed = () => setTimeout(() => { startTour = true; }, 300);
  //     if (document.readyState === 'complete') {
  //       startTourDelayed();
  //     } else {
  //       window.addEventListener('load', startTourDelayed, { once: true });
  //     }
  //   }
  // });

  // function handleTourEnd() {
  //   localStorage.setItem(TOUR_STORAGE_KEY, "true");
  //   startTour = false;
  // }
</script>

<svelte:window bind:innerWidth={windowWidth} />

<!-- <TourGuide
  variant="news"
  startMode="auto"
  start={startTour}
  steps={tourSteps}
  showButton={false}
  bind:tourInProgress
  on:tour-finished={handleTourEnd}
  on:tour-closed={handleTourEnd}
/> -->

{#await i18nSetup then}
<div class="calculator-hero">
  <div class="calculator-hero__inner">
    <img src={logoSrc} alt="flecha_bsale" class="calculator-hero__arrow">
    {#if windowWidth < 768}
      <div class="calculator-hero__mobile-title">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <span class="calculator-hero__mobile-title-bold" on:click={globalStore.toggleVerticalMenu}>
          {$_("home.title_bold_mobile")}
        </span>
        <span class="calculator-hero__mobile-title-regular">
          {$_("home.title_mobile")}
        </span>
      </div>

      <div class="calculator-hero__nav-buttons">
        {#each navbarOptions as item}
          <ButtonV2
            variant="primary"
            fullWidth={true}
            href={$country ? `${item.href}?country=${$country}` : item.href}
          >
            {$_(item.label)}
          </ButtonV2>
        {/each}
      </div>
    {:else}
      <div class="calculator-hero__eyebrow">
        <img src={iconLightBulb} alt="light_bulb" style="width: 46px;">
        <div class="calculator-hero__eyebrow-text">
          <span class="calculator-hero__eyebrow-bold">{$_("home.title_bold")}</span>
          <span class="calculator-hero__eyebrow-regular">{$_("home.title")}</span>
        </div>
      </div>

      <h1 class="calculator-hero__title">
        {$_("home.title_bold_v2")}
      </h1>

      <div class="calculator-hero__divider"></div>

      <p class="calculator-hero__description">
        {$_("home.subtitle")}
      </p>
    {/if}
  </div>
  {#if windowWidth >= 768}
    <img src="/images/background_bsale.svg" alt="fondo Bsale" class="calculator-hero__illustration">
  {/if}
</div>
{/await}